(() => {
  const repair = () => {
    document.querySelectorAll('.sgpf[style*="background:#002E22"] [style*="color:#000000"]').forEach((element) => {
      let ancestor = element.parentElement;
      let onLightSurface = false;
      while (ancestor && !ancestor.matches('.sgpf[style*="background:#002E22"]')) {
        if ((ancestor.getAttribute('style') || '').includes('background:#fff')) { onLightSurface = true; break; }
        ancestor = ancestor.parentElement;
      }
      if (!onLightSurface) element.style.setProperty('color', '#ffffff', 'important');
    });
    document.querySelectorAll('a[href^="tel:+14246009901"]').forEach((element) => {
      const isWittek = element.closest('#root')?.querySelector('.sg-wittek-order-details');
      element.style.setProperty('color', isWittek ? '#002e22' : '#C5A55A', 'important');
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', repair);
  else repair();
})();
